import { Text } from '@chakra-ui/react'

export interface DescricaoProps {
  descricao: string
}
export const Descricao = ({ descricao }: DescricaoProps) => {
  return <Text fontSize={'14px'}>{descricao}</Text>
}
